// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChevronsLeft as RawChevronsLeft } from "lucide-react";
export const ChevronsLeft = /* @__PURE__ */ createIcon(RawChevronsLeft, "ChevronsLeft", 2);
